import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { RoleService } from '../roles/role.service';
import { Roles } from '../roles/role-settings.model';
import { StateService } from '../state-manager/appstateservice';
import { NavigationService } from '../navigations/navigation.service';

@Injectable()
export class OktaAuthGuard implements CanActivate {
  constructor(private router: Router, private roleService: RoleService,
              private stateService: StateService, private navigationService: NavigationService) { }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.stateService.isTokenValid) {
      if (this.stateService.isUnAuthorized()) {
        this.router.navigate(['/not-authorized-page']);
        return false;
      }
      const role: Roles[] = this.roleService.getRole();
      // const currentRole string[] = role.map(r => Roles[r])
      const isViewasAdmin = this.roleService.isViewAsAdmin(role);
      
      
      if (!isViewasAdmin && route.data.permissions) {  
        route.data.permissions.find((x: string) => {
          const hasPermission = this.stateService.permissionCheck(x);
  
          if (!hasPermission) { 
            this.router.navigate(['/not-authorized-page']);
            return false;
          }
        });
      }
      
      const group = this.stateService.getGroupSession();
      
      if (group && route.data.groups && route.data.groups.indexOf(group) === -1) {
        this.router.navigate(['/not-authorized-page']);
        return false;
      }
      
      if (!this.navigationService.isFeatureSupported(group, route.data.feature)) {
        this.router.navigate(['/not-authorized-page']);
        return false;
      }

      return true;
    } else {
      this.stateService.removeToken();
    }

    this.router.navigate(['/'], { queryParams: { redirecturl: state.url }});
    return false;
  }
}
